module.exports = {
      id: "ic-rectangle-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#ic-rectangle-usage",
      toString: function () {
        return this.url;
      }
    }